<div class="content">
  <!-- Breadcrumb only -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div class="my-auto mb-2">
      <h2 class="mb-1">Birthdays</h2>
    </div>
  </div>

  <!-- FULL WIDTH CARD -->
  <div class="card w-100">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap">
      <h5>🎂 Employee Birthdays</h5>

      <div class="d-flex gap-2">
        <select
          class="form-select form-select-sm"
          style="width: 90px"
          [(ngModel)]="pageLimit"
          (change)="loadBirthdays()"
        >
          <option *ngFor="let limit of [10, 20, 50, 100]" [value]="limit">{{ limit }}</option>
        </select>

        <input
          type="text"
          [(ngModel)]="search"
          (ngModelChange)="onFilterChange()"
          class="form-control"
          placeholder="Search Employees"
        />
      </div>
    </div>

    <div class="card-body p-0">
      <table
        class="table table-hover mb-0"
        *ngIf="birthdayList && birthdayList.length > 0; else noData"
      >
        <thead>
          <tr>
            <th>Employee</th>
            <th>Department</th>
            <th>Date</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let emp of birthdayList">
            <td>
              <div class="d-flex align-items-center">
                <img
                  *ngIf="emp.picture; else initials"
                  [src]="apiEndpoint + '/uploads/' + emp.picture"
                  class="rounded-circle border border-2"
                  style="width: 40px; height: 40px"
                  alt="img"
                />

                <ng-template #initials>
                  <div
                    class="rounded-circle d-inline-flex align-items-center justify-content-center bg-primary text-white fw-bold border border-2"
                    style="width: 40px; height: 40px"
                  >
                    {{ emp.firstName[0] }}{{ emp.lastName[0] }}
                  </div>
                </ng-template>

                <div class="ms-2">{{ emp.firstName }} {{ emp.lastName }}</div>
              </div>
            </td>

            <td>{{ emp.designation?.department?.departmentName || 'N/A' }}</td>
            <td>{{ emp.birthdate | date: 'dd MMM' }}</td>

            <td class="text-end">
              <button
                *ngIf="isTodayBirthday(emp.birthdate)"
                class="btn btn-sm btn-success"
                (click)="sendBirthdayWish(emp.id)"
              >
                🎉 Send Wishes
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #noData>
        <div class="text-center">Record not available</div>
      </ng-template>
    </div>

    <!-- Pagination -->
    <div
      class="d-flex justify-content-between align-items-center p-2"
      *ngIf="birthdayList.length > 0"
    >
      <div>
        Showing {{ (currentPage - 1) * pageLimit + 1 }} to {{ pageLastRecord }} of {{ totalCount }}
      </div>

      <app-pagination
        [currentPage]="currentPage"
        [pageSize]="pageLimit"
        [totalRows]="totalCount"
        (pageChange)="onPageChange($event)"
      >
      </app-pagination>
    </div>
  </div>
</div>
